import { DatePipe, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';

import { DurationPipe } from '@bn/shared/core/pipes';

import { UserFeed } from './models/user-feed.model';

@Component({
  selector: 'bn-web-ui-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  imports: [NgClass, FaIconComponent, TooltipDirective, DatePipe, DurationPipe],
})
export class BnNotificationItemComponent {
  @Input()
  public set notification(value: UserFeed) {
    this._notification = value;

    this.content = value.description.replaceAll('<a', '<a target="_blank"');
  }

  @Input()
  public showAll = false;

  @Input()
  public redirectToFeedUrl = false;

  @Input()
  public extraClass = '';

  /** Shows the relative "time ago" meta. Off on the changelog page (the date lives in that page's
   * per-entry divider); on by default elsewhere - e.g. the notifications dropdown. */
  @Input()
  public showTimestamp = true;

  public _notification?: UserFeed;
  public content?: string;
}
